import { Injectable } from '@angular/core';

import {
  filter,
  fromEvent,
  map,
  Observable,
  share,
  Subject,
  Subscription,
  takeUntil
} from 'rxjs';

import { environment } from '@env/environment';

import { BemobiCheckoutMessage } from '../models/bemobi-checkout-message.model';
import {
  isAllowedBemobiOrigin,
  parseBemobiMessage
} from '../utils/bemobi-message.parser';

@Injectable()
export class BemobiCheckoutWebhookService {
  private readonly allowedOrigins = environment.checkout.bemobi.allowedOrigins;

  private stopListening$ = new Subject<void>();
  private listenerSubscription: Subscription | null = null;

  /**
   * Escuta eventos postMessage do iframe Bemobi (webhook client-side).
   * Chame stopListening() ao encerrar o checkout.
   */
  listen(): Observable<BemobiCheckoutMessage> {
    this.stopListening();

    return fromEvent<MessageEvent>(window, 'message').pipe(
      takeUntil(this.stopListening$),
      filter((event) =>
        isAllowedBemobiOrigin(event.origin, this.allowedOrigins)
      ),
      map((event) => parseBemobiMessage(event.data)),
      filter((message): message is BemobiCheckoutMessage => message !== null),
      share()
    );
  }

  startListening(handler: (message: BemobiCheckoutMessage) => void): void {
    this.stopListening();
    this.listenerSubscription = this.listen().subscribe(handler);
  }

  stopListening(): void {
    this.listenerSubscription?.unsubscribe();
    this.listenerSubscription = null;
    this.stopListening$.next();
    this.stopListening$.complete();
    this.stopListening$ = new Subject<void>();
  }
}
